import React from 'react';

const DevicesPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/devices',
			exact: true,
			component: React.lazy(() => import('./DevicesPage')),
		},
		{
			path: '/admin/devices/register',
			exact: true,
			component: React.lazy(() => import('./UniversalPrintDevicePage')),
		},
	],
};

export default DevicesPageConfig;
